<template>
  <div class="home">
    <div class="head-title">跟踪记录更新</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="(onSubmit = true), rolene()"
            >添加</el-button
          >
          <el-table
            :data="tableData.data"
            border
            stripe=""
            style="width: 100%; text-aligh: center; margin-top: 2.0rem"
          >
            <el-table-column
              prop="account"
              label="代理商"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="用户手机号"
              style="width: 10%"
            ></el-table-column>

            <el-table-column
              prop="addtime"
              label="时间"
              style="width: 30%"
            ></el-table-column>
            <el-table-column
              prop="record"
              label="日志内容"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                ></el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="
                    (dialogVisible = true),
                      modify(
                        scope.row.id,
                        scope.row.role_id,
                        scope.row.username,
                        scope.row.record,
                        scope.row.is_deny
                      )
                  "
                  >编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="abo"
            />
          </div>
        </div>
        <el-dialog
          title="修改跟踪记录"
          center
          :visible.sync="dialogVisible"
          width="30%"
        >
          <el-form ref="form" :model="form" label-width="8.0rem">
            <el-form-item label="日志内容">
              <el-input clearable type="textarea" autosize="true" v-model="modifys.l">{{
                modifys.l
              }}</el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="添加跟踪记录" center  :visible.sync="onSubmit" width="30%">
          <el-form ref="form" :model="form" label-width="8.0rem">
            <el-form-item label="日志内容">
              <el-input
                clearable
                type="textarea"
                autosize="true"
                v-model="form.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="选择用户">
              <el-select clearable v-model="form.role" placeholder="请选择">
                <el-option
                  v-for="(item, index) in role"
                  :value="item.id"
                  :key="index"
                  :label="item.phone"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import md5 from "js-md5";
export default {
  data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      formInline: {
        user: "",
      },
      dialogVisible: false,
      form: {
        name: "",
        money: "",
        role: "",
      },
      onSubmit: false,
      modifys: {
        e: "",
        l: "",
        aboue: "",
      }, //修改点击来接收的id,modifys.aboue
      dengj: "", //获取修改名称的
      shoujia: "", //获取修改售价的
      tooken: "",
      username: {},
      role: [],
      name: "",
      mima: "******",

      value: "",
      dataane: [],
      id: "",
      listQuery: {
        page: 1,
        limit: 20
      }
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }

    this.abo();
    this.rouber();
  },
  methods: {
    // 页数
    handleCurrentChange(val) {
      this.axios
        .post(
          "/api/record/getRecordList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
            page: val,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        });
    },
    rouber() {
      this.axios
        .post(
          "/api/role/getRoleList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.dataane = res.data.data;
        })
        .catch(function (err) {});
    },
    rolene() {
      this.axios
        .post(
          "/api/agent/getAgentAccounts",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.role = res.data.data;
        })
        .catch(function (err) {});
    },
    abo() {
      this.axios
        .post(
          "/api/record/getRecordList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    //  通过点击事件触发监听事件
    modify(e, l, p, o, el) {
      this.name = p;
      this.modifys.e = e;
      this.dengj = l;
      this.modifys.l = o;
    },
    //修改代理商等级/api/admins/getUserList
    vak() {
      // 修改代理商等级
      this.axios
        .post(
          "/api/record/editRecord",
          qs.stringify({
            id: this.modifys.e,
            record: this.modifys.l,
            // password: this.modifys.l,
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.dialogVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.dialogVisible = true;
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.abo();
        })
        .catch(function (err) {});
    },

    handleClick(row) {},

    // 添加权限
    numoo() {
      if (this.form.name !== "") {
        this.axios
          .post(
            "/api/record/addRecord",
            qs.stringify({
              record: this.form.name,
              agenttoken: this.username.agenttoken,
              agent_id: this.username.id,
              user_account_id: this.form.role,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            if (res.data.code == 1) {
              this.onSubmit = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.onSubmit = true;
              this.$message.error(res.data.msg);
            }
            this.abo();
          })
          .catch(function (err) {});
      } else {
        this.$message.error("添加权限不能为空");
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table thead {
  color: #FFFFFF;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 1.0rem 31px;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}
</style>

